import React from "react";
import upload_photo from "../../assets/icons/upload.png";
import { Image } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import UploadImageErrorModal from "./../../components/modals/UploadImageErrorModal";

export default ({
  uploadfileManually,
  isActive,
  files,
  imageUrl,
  loader,
  iscompletedForm,
  checkImagedimension,
  imageValidated,
  ImgHeight,
  ImgWidth,
  confirmShow,
  confirmonHide,
  validationError,
}) => {
  const imgEl = React.createRef();
  return (
    <div className={`pic_upload_box ${loader ? "loader-div-show" : ""}`}>
      {loader ? (
        <Spinner animation="grow" />
      ) : imageUrl ? (
        <div className="image-upload-div">
          <Image src={imageUrl} style={{ width: "100%", height: "100%" }} />
          <img
            style={{ marginBottom: "10px", display: "none" }}
            src={imageUrl}
            ref={imgEl}
            onLoad={() =>
              imgEl?.current?.naturalWidth >= 800 &&
              imgEl?.current?.naturalHeight >= 1200
                ? checkImagedimension(true)
                : imageValidated
                ? checkImagedimension(false, imgEl)
                : ""
            }
          />
          <span>
            {!iscompletedForm ? (
              <input type="file" onChange={uploadfileManually}></input>
            ) : (
              ""
            )}
          </span>
        </div>
      ) : (
        <div
          className="upload_box_inner"
          style={{
            backgroundColor: !imageUrl
              ? validationError?.data
                ? "#fff1f1"
                : ""
              : "",
            borderColor: !imageUrl
              ? validationError?.data
                ? "#fa4a4a"
                : ""
              : "",
          }}
        >
          <div className="button_wrap">
            <div
              className="upload_photo_btn"
              style={{
                backgroundColor: !imageUrl
                  ? validationError?.data
                    ? "#fa4a4a"
                    : ""
                  : "",
              }}
            >
              <span className="upload-txt">
                {" "}
                <img
                  src={upload_photo}
                  alt="upload_photo"
                  style={{ marginRight: "5px" }}
                />
                Upload photo
              </span>
              <span>
                {!iscompletedForm ? (
                  <input
                    type="file"
                    onChange={uploadfileManually}
                    style={{ width: "170px", height: "70px", opacity: 0 }}
                  ></input>
                ) : (
                  ""
                )}
              </span>
            </div>

            <p
              style={{
                color: !imageUrl
                  ? validationError?.data
                    ? "#fa4a4a"
                    : ""
                  : "",
              }}
            >
              {isActive ? "Release to drop" : "Or Drag them in"}
            </p>
            <p
              style={{
                color: !imageUrl
                  ? validationError?.data
                    ? "#fa4a4a"
                    : ""
                  : "",
              }}
            >
              {files?.length ? files[0].name : ""}
            </p>
          </div>
        </div>
      )}
      <UploadImageErrorModal
        confirmShow={confirmShow}
        ImgHeight={ImgHeight}
        ImgWidth={ImgWidth}
        confirmonHide={confirmonHide}
        onUpload={uploadfileManually}
        loader={loader}
      />
    </div>
  );
};
